function CreateAnnounceDurationPicker(arg) {
    $('#announcementDuration').durationPicker();

}

function GetAnnounceDurationPickerValue(arg) {
    var value = $('#announcementDuration').val();
    var minutes = 0;
    try {
        minutes = Math.floor((parseInt(value) / 1000) / 60);
    } catch (e) {

    }
    console.log("value is: " + minutes);
    return minutes.toString();
}

function ShowAnnouncementFullText(text) {

    console.log("here");
    console.log(text);

    if (text != null) {
        try {
            text = text.replace(/&quot;/g, '\"');
        } catch (e) {

        }
        //text = text.replaceAll("&quot;", "\"");
    }

    swal({
        title: "",
        text: text,
        customClass: 'swal-wide-column-tips'
    });
}

function confirmClearAnnouncement(announcementId) {

    swal({
        title: "Are you sure?",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel.",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {
            try {
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnClearAnnouncementConfirmed', announcementId);
            } catch { }

            try {
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnClearAnnouncementConfirmed', announcementId);
            } catch { }

        });
}



function InitOperationResidentSpecificAnnouncementTypeahead(people) {

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        if (name !== "") {
            peopleRaw.push(unit + ", " + name);
        }
    }

    buildTypeahead('#announcementReceiverSelect .typeahead', "people", peopleRaw);

    return true;
}

function SetResidentSpecificCheckboxToFalse(arg) {
    $('#residentSpecificSwitch').prop('checked', false);
}



function confirmBroadcastNotification(name, unit, receiverphone, receivermail, content, sendtext, sendemail, external, residentCount) {

    var userMessage = "Are you sure you want to send the following " + (sendtext ? "text" : "") + (sendtext & sendemail ? " and " : " ") + (sendemail ? "email" : "") +
        ": \n\n" + content + "\n\n";

    swal({
        title: "Broadcast confirmation",
        text: userMessage,
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-success",
        confirmButtonText: "Yes",
        closeOnConfirm: false
    },
        function () {

            swal({
                title: "Broadcast confirmation",
                text: "Write '" + "yes" + "' below",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: "Broadcast",
                inputPlaceholder: ""
            }, function (inputValue) {
                if (inputValue === false) return false;
                if (inputValue === "") {
                    //swal.showInputError("You need to write something!");
                    return false
                }

                if (inputValue == "yes") {

                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnSendManualNotificationConfirmed', 'broadcast');
                    swal("Broadcast" + " sent", "See the archive page to see a list of all sent notifications", "success");
                    //DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnSiteDeleteConfirmed', siteId);
                    //swal("Removed.", siteNameToDelete + " was removed", "success");
                }

            });


        });

    //swal({
    //    title: "Confirmation",
    //    text: 
    //    type: "info",
    //    showCancelButton: true,
    //    confirmButtonClass: "btn-success",
    //    confirmButtonText: "Yes, send.",
    //    closeOnConfirm: false
    //},
    //    function () {
    //        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnSendManualNotificationConfirmed', '-');


    //        swal("Notification" + (sendtext & sendemail ? "s" : "") + " sent", "See the analytics page to see the statuses of all notifications", "success");

    //    });
}

function notesSavedSuccess(arg) {
    swal({
        title: "Saved",
        text: "Noted saved",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}

function announcementSentSuccess(arg) {
    swal({
        title: "Sent",
        text: "Bulletin sent",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}

function showPhoneNumberHelp(arg) {
    swal({
        title: "Phone number format",
        text: "\nEnter the phone number without hyphens, dots, spaces or parentheses.\n\nExample: 8556554826\n\n",
        type: "info",
        showCancelButton: false,
        showConfirmButton: true
    });

}






function createOperationPageTooltip(el, text) {


    setTimeout(function () {
        tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

//Phone Input Component Start

function maskField(el, textformat) {
    if (el == null || el == undefined) {
        return false;
    }
    try {
        $(function () {
            try {
                $(el).unmask();
            }
            catch { }
            $(el).mask(textformat);
            return true;
        });
    }
    catch (e) { }
    return false;
}

function removeAHrefTag(el) {
    try {
        $(function () {
            $('.phone-input-link-dyn-element').contents().unwrap();
            $(el).css('color', '#424242');
            $(el).css('cursor', 'text');
        });
    }
    catch (e) { }
}
function addAHrefTag(el, ahrefhtml) {
    try {
        $(function () {
            $(el).wrap(ahrefhtml);
        });
    }
    catch (e) { }
}

function colorAHrefTag(el) {
    try {
        $(function () {
            $(el).css('color', '#2196F3');
            $(el).css('cursor', 'pointer');

        });
    }
    catch (e) { }
}

//Phone Input Component End